<script lang="ts">
	import { ModeWatcher } from 'mode-watcher';
	import { page } from '$app/stores';
	import Footer from '$lib/components/Footer.svelte';
	import Navigation from '$lib/components/Navigation.svelte';
	import PageTransition from '$lib/components/PageTransition.svelte';
	import { Toaster } from '$lib/components/ui/sonner';
	import MultiTourDiscountDialog from '$lib/components/MultiTourDiscountDialog.svelte';
	import '../app.pcss';
	import ThirdPartyScripts from '$lib/components/ThirdPartyScripts.svelte';

	let { data, children } = $props();
</script>

<ThirdPartyScripts />
<ModeWatcher defaultMode={'light'} />
<Toaster position="top-right" />
{#if !($page.url.pathname === '/tours' && $page.url.hash === '#giftCards')}
	<MultiTourDiscountDialog />
{/if}
<Navigation />
<PageTransition key={data.url}>
	<main>
		{@render children?.()}
	</main>
</PageTransition>
<Footer />
